import type { WiwState } from '@/store';

export const getConnected = (state: WiwState) => {
  return state.workchat.connected;
};
